import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M16.05 3.74938C16.44 3.35938 16.44 2.72938 16.05 2.33937C15.66 1.94938 15.03 1.94938 14.64 2.33937C14.25 2.72938 14.25 3.35938 14.64 3.74938C15.03 4.13938 15.66 4.13938 16.05 3.74938Z" }), jsx("path", { fill: "currentColor", d: "M21.25 8.8091C20.86 8.4191 20.23 8.4191 19.84 8.8091C19.45 9.1991 19.45 9.8291 19.84 10.2191C20.23 10.6091 20.86 10.6091 21.25 10.2191C21.64 9.8291 21.64 9.1991 21.25 8.8091Z" }), jsx("path", { fill: "currentColor", d: "M2.45001 20.5595L3.85001 21.9595L17.64 15.1095L9.30001 6.76953L2.45001 20.5595ZM7.48001 14.9295L11.61 15.8695L5.51001 18.8995L7.48001 14.9295ZM14.1 14.3895L8.40001 13.0895L9.86001 10.1495L14.1 14.3895Z" }), jsx("path", { fill: "currentColor", d: "M18.3346 11.5736L17.8528 13.5146L20.7547 14.235L21.2365 12.2939L18.3346 11.5736Z" }), jsx("path", { fill: "currentColor", d: "M14.35 9.29965L16.25 9.92965L16.8 8.28965L18.95 7.56965L19.53 5.57965L21.15 5.03965L20.52 3.13965L17.9 4.00965L17.32 6.00965L15.22 6.70965L14.35 9.29965Z" }), jsx("path", { fill: "currentColor", d: "M12.4576 3.51272L10.5364 4.06836L11.3809 6.98869L13.3022 6.43305L12.4576 3.51272Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconPartyPopper = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconPartyPopper.displayName = "IconPartyPopper";

export { IconPartyPopper };
